// extracted by mini-css-extract-plugin
export default {"uploaded":"styles_uploaded__b3wi7","btn":"styles_btn__T19UW","textUploaded":"styles_textUploaded__k5TZj"};